import { CIcon } from '~/icons/types'

export const ciShieldCheck: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm20.35 4.06-8-3a1.051 1.051 0 0 0-.7 0l-8 3A1.007 1.007 0 0 0 3 5v7c0 6.54 8.2 10.72 8.55 10.89a.975.975 0 0 0 .9 0C12.8 22.72 21 18.54 21 12V5a1.007 1.007 0 0 0-.65-.94Zm-4.29 7-4 4a1.5 1.5 0 0 1-2.12 0l-2-2a1.5 1.5 0 1 1 2.12-2.12l.94.94 2.94-2.94a1.5 1.5 0 1 1 2.12 2.12Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'shield-check',
  type: 'solid'
}
